var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-partial'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Thank You")]),_c('p',[_vm._v("Your response has been received.")])])
}]

export { render, staticRenderFns }